import { SparkleIcon } from "@phosphor-icons/react/dist/csr/Sparkle";
import type { ReactNode } from "react";
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@volca/ui/components/ui/empty";
import { emptyStateVariants } from "@volca/ui/lib/empty-state";
import { HarnessChatSuggestedPrompts } from "./harness-chat-suggested-prompts";

interface HarnessChatEmptyStateProps {
  title: string;
  description?: string;
  prompts: string[];
  disabled: boolean;
  onSend: (prompt: string) => void;
  children?: ReactNode;
}

export const HarnessChatEmptyState = ({
  title,
  description,
  prompts,
  disabled,
  onSend,
  children,
}: HarnessChatEmptyStateProps) => (
  <Empty
    className={emptyStateVariants({
      layout: "workspace",
      className: "gap-6 pt-6",
    })}
  >
    <EmptyHeader>
      <EmptyMedia variant="icon">
        <SparkleIcon aria-hidden />
      </EmptyMedia>
      <EmptyTitle>
        <h3>{title}</h3>
      </EmptyTitle>
      {description && <EmptyDescription>{description}</EmptyDescription>}
    </EmptyHeader>
    {children}
    <EmptyContent className="max-w-none items-stretch">
      <HarnessChatSuggestedPrompts
        prompts={prompts}
        disabled={disabled}
        onSend={onSend}
      />
    </EmptyContent>
  </Empty>
);
